module.exports = __webpack_public_path__ + "static/media/dumbell.cfb3717d.png";